import { params } from 'store/params.store'
import { ref } from 'vue'
import { useSessionStorage, useUrlSearchParams } from '@vueuse/core'

// pega os parametros da url e guarda na session storage
export default function useIframeParams() {
  
  const urlParams = ref(useUrlSearchParams())

  const initialSearchParams = useSessionStorage('initialSearchParams', '{}')

  if (Object.keys(urlParams.value)?.length) {
    initialSearchParams.value = JSON.stringify(urlParams.value)
  }

  params.value = initialSearchParams.value
}
